const emojipedia = [
  {
    id: 1,
    emoji: '💪',
    name: 'Tense Biceps',
    meaning:
      '“You can do that!” or “I feel strong!” Arm with tense biceps. Also used in connection with doing sports, e.g. at the gym.',
  },
  {
    id: 2,
    emoji: '🙈',
    name: 'See-No-Evil Monkey',
    meaning:
      'Monkey Face with hands covering its eyes, used as a playful way to convey a laughing, disbelieving, cringing I can’t believe what I’m seeing! or I can’t bear to look!',
  },
  {
    id: 3,
    emoji: '🤣',
    name: 'Rolling On The Floor, Laughing',
    meaning:
      'This is funny! A smiley face, rolling on the floor, laughing. The face is laughing boundlessly. The emoji version of “rofl“. Stands for „rolling on the floor, laughing“.',
  },
  {
    id: 4,
    emoji: '🙏',
    name: 'Person With Folded Hands',
    meaning:
      'Two hands pressed together. Is currently very introverted, saying a prayer, or hoping for enlightenment. Is also used as a “high five” or to say thank you.',
  },
  {
    id: 5,
    emoji: '🤑',
    name: 'Money-Mouth Face',
    meaning:
      'A yellow face with dollar signs for eyes, and an open smile sticking out a dollar banknote as a tounge. Used for a wide range of content dealing with money, including: making money, loving wealth, being or feeling rich',
  },
  {
    id: 6,
    emoji: '🦊',
    name: 'Fox',
    meaning:
      'A friendly, cartoon-styled faced of a fox, often used with an affectionate or playful tone (e.g., slang, foxy). The team Foxes also happens to be the best team in Technigo Bootcamp fall 2021 💖',
  },
];

export default emojipedia;

